import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import Modal from "react-modal";
import Loader from '../../../utils/Loader'
import { useNavigate, Link } from "react-router-dom";
// import Footer from '../../common_components/Footer';
import VisitorHeader from '../../../common_components/visitor_module_header';
import AdminHeader from '../../../common_components/admin_module_header';
import { getVisitorQRcode_action, getVisitorBadge_action } from "../../../actions/visitor_module_action/visitor_registration_action/visitor_registration_action";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { badgeReportName, DOC_BASE_URL, downloadReport, fetchDocReport, toastError } from "../../../utils/constants";
import axios from "axios";

class VisitorThankYou extends Component {
    // Intialized Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            geturl: "",
            is_partner: false,
            exhibitionAdd: '',
            exhibitionName: '',
            ExhRegistrationNo: '',
            fromDate: '',
            toDate: '',

            isClickValidation: false,
            scripts: [],
            QRList: []
        }
        this.onPreviousClick = this.onPreviousClick.bind(this)
        this.getVisitorBadge = this.getVisitorBadge.bind(this)

    }

    componentWillUnmount() {
        const { isClickValidation, scripts } = this.state
        sessionStorage.clear()
        // if (!isClickValidation) {
        //     window.location.replace('http://localhost:3000/#/');
        // }

        if (scripts) {
            scripts.forEach((script) => {
                if (script.parentNode) {
                    script.parentNode.removeChild(script);
                }
            });
        }
    }


    async callGAScripts() {
        const { scripts } = this.state
        const script1 = document.createElement("script");
        script1.async = true;
        script1.src = "https://www.googletagmanager.com/gtag/js?id=G-1QY8MXN64V";
        document.head.appendChild(script1);
        scripts.push(script1); // Store reference

        const script2 = document.createElement("script");
        script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-1QY8MXN64V');
    `;
        document.head.appendChild(script2);
        scripts.push(script2)
    }

    // On Component Load
    componentDidMount() {
        console.log('session : ',sessionStorage);
        if(sessionStorage.getItem('sessionExhibitionID') != null){
            this.callGAScripts()
            console.log('JSON.parse(sessionStorage.getItem()', (sessionStorage.getItem('VisitorDataSS')), sessionStorage.getItem('sessionLogoPath'))
            sessionStorage.setItem('completed', true);
            console.log('route : ', this.props);
            // Exhibition From Date
            const dateString = sessionStorage.getItem('exhibitionDateFrom');
            const dateStringMoment = moment.utc(dateString, "DD/MM/YYYY").format('DD MMMM YYYY')
            const dateObject = new Date(dateStringMoment);
            const fromDay = dateObject.getDate();
            const fromMonth = dateObject.toLocaleString('default', { month: 'long' });
            const fromYear = dateObject.getFullYear();
            const ExfromDate = `${fromDay} ${fromMonth} ${fromYear}`;
            console.log('dateString', dateString)
            console.log('dateStringMoment', dateStringMoment)
            console.log('dateObject', dateObject)
    
            // Exhibition to Date
            const dateString1 = sessionStorage.getItem('exhibitionDateTo');
            const dateString1Moment = moment.utc(dateString1, "DD/MM/YYYY").format('DD MMMM YYYY')
            const dateObject1 = new Date(dateString1Moment);
            const toDay = dateObject1.getDate();
            const toMonth = dateObject1.toLocaleString('default', { month: 'long' });
            const toYear = dateObject1.getFullYear();
            const ExtoDate = `${toDay} ${toMonth} ${toYear}`;
            this.setState({
                geturl: (sessionStorage.getItem('sessionExhMailWebsite') != null && sessionStorage.getItem('sessionExhMailWebsite') != '') ? sessionStorage.getItem('sessionExhMailWebsite') : '',
                // is_partner: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.is_partner != " " ? this.props.location.state.is_partner : '',
                exhibitionAdd: (sessionStorage.getItem('exhibitionAddress') != null && sessionStorage.getItem('exhibitionAddress') != '') ? sessionStorage.getItem('exhibitionAddress') : '',
                exhibitionName: (sessionStorage.getItem('sessionExhibitionName') != null && sessionStorage.getItem('sessionExhibitionName') != '') ? sessionStorage.getItem('sessionExhibitionName') : '',
                // ExhRegistrationNo: exhno,
                fromDate: (sessionStorage.getItem('exhibitionDateFrom') != null && sessionStorage.getItem('exhibitionDateFrom') != '') ? ExfromDate : '',
                toDate: (sessionStorage.getItem('exhibitionDateTo') != null && sessionStorage.getItem('exhibitionDateTo') != '') ? ExtoDate : '',
            }, () => {
                this.getVisitorRegistrationDetails()
            })
        }
    
    }

    getVisitorRegistrationDetails() {
        // setTimeout(() => {
        const { attendeeList, daysList, industryChapterList, educationRoleTypeId, visitPurposeList, interestList, seminarInterestList, primaryChapterListData,
            level2, level3, level4 } = this.state
        console.log(interestList, ';;')
        var noArr = sessionStorage.getItem('VisitorTypeID') == 2 ? JSON.parse(sessionStorage.getItem('VisitorDataSS')).VisitorRegistrationNos.split(',') : [JSON.parse(sessionStorage.getItem('VisitorDataSS')).VisitorRegistrationNo]
        var idArr = sessionStorage.getItem('VisitorTypeID') == 2 ? JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorIDs.split(',') : [JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID]
        // this.setState({ isLoading: true })
        this.props.getVisitorQRcode_action(sessionStorage.getItem('VisitorTypeID') == 2 ? JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorIDs : JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID)
            .then((data) => {
                console.log(data.data, noArr, idArr)
                data.data.length > 0 && data.data.map(item => {
                    idArr.length > 0 && idArr.map((item2, i) => {
                        if (item.ExhVisitorID == item2) {
                            item.VisitorRegistrationNo = noArr[i]
                        }
                    })
                })
                if (data.error != 1) {
                    this.setState({
                        QRList: data.data.length > 0 ? data.data : []
                    })
                }
            })
    }


    // On Component Close
    // componentWillUnmount() {
    //     sessionStorage.clear()
    // }

    // On Previous
    onPreviousClick(e) {
        e.preventDefault();
        this.setState({ isClickValidation: true }, () => {
            sessionStorage.clear()
            const win = window.location.replace(this.state.geturl, '_blank');
            // const win = window.open(this.state.geturl, '_blank');
            if (win != null) {
                win.focus();
            }
        })
    }

    // Get Visitor Badge
    // getVisitorBadge(id) {
    //     this.setState({ isLoading: true })
    //     this.props
    //         .getVisitorBadge_action(id)
    //         .then((data) => {
    //             if (data != null) {
    //                 this.setState({ isLoading: false })
    //                 console.log('Report data : ', data);
    //                 var url;
    //                 url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
    //                 const win = window.location.replace(url, '_blank');
    //                 if (win != null) {
    //                     win.focus();
    //                 }
    //             } else {
    //                 this.setState({ isLoading: false })
    //                 toastError('There is some problem to download report. Please try again later!', {
    //                     theme: 'colored',
    //                     autoClose: 3000,
    //                     hideProgressBar: true,
    //                 })
    //             }
    //         })
    //         .catch((e) => {
    //             console.log(e);
    //             this.setState({ isLoading: false })
    //         });
    // }

    async getVisitorBadge(id) {
        this.setState({ isLoading: true })
        var list = [];
        const mapdata1 = {
            "ParameterName": "@ExhibitionID",
            "ParameterValue": sessionStorage.getItem('sessionExhibitionID'),
            "ParameterDataType": "int"
        }
        list.push(mapdata1);
        const mapdata2 = {
            "ParameterName": "@VisitorID",
            "ParameterValue": id,
            "ParameterDataType": "int"
        }
        list.push(mapdata2);

        const mapData = {
            "report_name": badgeReportName,
            "parameter_details": list
        }

        const res = await axios.post(
            fetchDocReport,
            mapData,
            { responseType: "arraybuffer" }
        )

        const base64 = btoa(
            new Uint8Array(res.data)
                .reduce((data, byte) => data + String.fromCharCode(byte), "")
        );

        this.handleExportPDF(base64, "VisitorBadge");

        this.setState({ isLoading: false });
    }

    handleExportPDF = (base64Data, fileName) => {
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length)
            .fill(0)
            .map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    render() {
        const { isLoading, exhibitionAdd, exhibitionName, QRList, fromDate, toDate } = this.state
        console.log('session : ',sessionStorage);
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (null)}
                <ToastContainer />
                {/* <!-- PAGE --> */}
                {!sessionStorage.getItem('sessionExhibitionID') ? (<AdminHeader isSteper={false} />) : (<VisitorHeader />)}
                {/* <!-- CONTAINER --> */}
                <div >
                    {/* <StepHeader /> */}

                    {/* <!-- ROW-1 --> {geturl}*/}
                    <div
                        className="main-content app-content mt-0" style={{ overflow: 'auto' }}>
                        <div className="side-app">
                            {!sessionStorage.getItem('sessionExhibitionID') ? (
                                <div style={{marginTop : "100px"}}>
                                     <strong style={{fontSize : "23px"}}>Your Form Already Submitted Successfully</strong>
                                               
                                </div>
                            ) : (
                                <div className="main-container container-fluid top-form-name">
                                <div className="row ">
                                    <form className="needs-validation " noValidate="">
                                        <div className="form-row mt-4">
                                            <div className="form-group col-md-12 p-4 thank-box" style={{ background: "#f6f6f6" }}>
                                                <div className="form-group mb-2">
                                                    <h4
                                                        className="mb-0 pt-2 pb-4 thank-top-mes new-thanks1"
                                                        style={{ color: "#318958" }}
                                                    >
                                                        <strong>Visitor Registration Form Submitted Successfully</strong>
                                                    </h4>
                                                    <p className="mb-3 mt-2 text-center com-font">
                                                        Thank you for submitting your Visitor Registration Form for
                                                    </p>
                                                    <p className="mt-1 mb-0 text-center com-font">
                                                        <span className='Heading-main-thanks'>
                                                            {exhibitionName} from {fromDate} to {toDate} </span>
                                                    </p>
                                                    <p className="mb-3 text-center com-font">
                                                        {exhibitionAdd}
                                                    </p>
                                                    <h5 className="mb-4 pt-1" style={{ fontWeight: "bold" }}>
                                                        <strong>Your Visitor Registration {sessionStorage.getItem('VisitorTypeID') == 2 ? 'Numbers are' : 'Number is'}
                                                            {/* <span className='Heading-main-thanks' > 2323232</span> */}
                                                            <span className='Heading-main-thanks' style={{ wordWrap: 'break-word', wordBreak: 'break-word', whiteSpace: 'normal' }}> {sessionStorage.getItem('VisitorTypeID') == 2 ? JSON.parse(sessionStorage.getItem('VisitorDataSS')).VisitorRegistrationNos : JSON.parse(sessionStorage.getItem('VisitorDataSS')).VisitorRegistrationNo}</span>
                                                        </strong>
                                                    </h5>
                                                    <p className="mb-0 mt-1 text-center com-font">
                                                        <strong>Note:</strong>Kindly check your registered email address for acknowledgement of application.
                                                    </p>
                                                </div>
                                                {QRList.length > 0 && QRList.length == 1 ? QRList.map(item => (
                                                    <div classname="mt-2 mb-4">
                                                        <img src={DOC_BASE_URL + item.QRCodePath} className="header-brand-img desktop-logo" alt="logo" />
                                                        <br />
                                                        <span style={{ scale: '0.8' }} id="copyButton" class="input-group-addon btn single-col1" title="Download Visitor Batch"
                                                            onClick={(e) => this.getVisitorBadge(item.ExhVisitorID)}> Download Visitor E-Badge <i class="fa fa-download mt-1" aria-hidden="true"></i>
                                                        </span>
                                                    </div>)) :
                                                    <div className="table-responsive mb-1">
                                                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                                            <tr key={Math.random()} >
                                                                <th className='text-center'>Visitor Registration No</th>
                                                                <th>Name</th>
                                                                <th className='text-center'>email id</th>
                                                                <th className='text-center' style={{ width: '50px' }}>QR Code</th>
                                                                <th className='text-center' style={{ width: '25px' }}>Visitor Badge</th>
                                                            </tr>
                                                            <tbody>
                                                                {QRList.map(item => (
                                                                    <tr>
                                                                        <td className='text-center'>{item.VisitorRegistrationNo}</td>
                                                                        <td >{item.personName}</td>
                                                                        <td className='text-center'>{item.Email}</td>
                                                                        <td className='text-center'><img src={DOC_BASE_URL + item.QRCodePath} className="header-brand-img desktop-logo" alt="logo" />
                                                                        </td>
                                                                        <td className='text-center' style={{ textAlign: 'center', alignItems: 'center', justifyContent: 'center', alignContent: 'center' }}>
                                                                            <span style={{ scale: '0.8' }} id="copyButton" class="input-group-addon btn single-col1" title="Download Visitor Batch"
                                                                                onClick={(e) => this.getVisitorBadge(item.ExhVisitorID)}><i class="fa fa-download mt-1" aria-hidden="true"></i>
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>}
                                                <div classname="">
                                                    <div classname="mt-1 mb-4">
                                                        <button
                                                            classname="btn btn-next-bot m-1"
                                                            style={{
                                                                background: "#007bff",
                                                                padding: "6px 20px",
                                                                fontSize: 14,
                                                                border: "1px solid #007bff",
                                                                borderRadius: 2,
                                                                color: "#fff",
                                                                marginTop: 16
                                                            }}
                                                            onClick={e => this.onPreviousClick(e)}
                                                        >
                                                            {" "}
                                                            BACK TO EVENT WEBSITE
                                                        </button>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            )}
                            

                        </div>
                    </div>


                </div>
                {/* <Footer /> */}
                {/* <!-- CONTAINER END --> */}

            </>
        );
    }
}

export default withRouter(connect(null, {
    getVisitorQRcode_action, getVisitorBadge_action
})(VisitorThankYou))
